import { Tooltip } from "@mui/material";
import React, { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import useGoToPage from "../../hook/useGoToPage";

type SparePartsInstalledBaseParams = {
    customerSiteCode?: string;
};

type SparePartsSearchParams = {
    code?: string;
};

type SparePartsMachineParams = {
    customerSiteCode?: string;
    machineId?: string;
    naturalKey?: string;
}

type SparePartsMachineMoreParams = {
    customerSiteCode?: string;
    machineId?: string;
    tabIndex?: string;
}

type PartDetailsParams = {
    partCode?: string;
}

export interface GTPProps {
    brand?: string;
    context?: "spareparts | system";
    page: "home" | "spareparts.installedbase" | "system.goToBasket" | "spareparts.goToSearch" | "spareparts.machine" | "spareparts.machineMore" | "spareparts.partDetails" | "system.offerOrderHistory";
    params?: SparePartsInstalledBaseParams | SparePartsSearchParams | SparePartsMachineParams | SparePartsMachineMoreParams | { param1: string };
    className?: string;
    tooltipTitle?: string;
    onClick?: any;
    disabled?: boolean;
}

const GoToPage: React.FC<PropsWithChildren<GTPProps>> = (
    props: PropsWithChildren<GTPProps>
) => {
    const goToPage = useGoToPage();
    let url: string = "";
    switch (props.page) {
        case "home": {
            url = goToPage.getHomeUrl();
            break;
        }
        case "system.goToBasket": {
            url = goToPage.system.getBasketUrl();
            break;
        }
        case "spareparts.goToSearch": {
            const code =
                (props.params as SparePartsSearchParams)?.code ?? "";
            url = goToPage.spareParts.getSearchUrl(code);
            break;
        }
        case "spareparts.installedbase": {
            const customerSiteCode =
                (props.params as SparePartsInstalledBaseParams)?.customerSiteCode ?? "";
            url = goToPage.spareParts.getInstalledBaseUrl(customerSiteCode);
            break;
        }
        case "spareparts.machine": {
            const machineId = (props.params as SparePartsMachineParams)?.machineId ?? "";
            const customerSiteCode = (props.params as SparePartsMachineParams)?.customerSiteCode ?? "";
            const naturalKey = (props.params as SparePartsMachineParams)?.naturalKey ?? "";
            url = goToPage.spareParts.getMachineUrl(customerSiteCode, machineId, naturalKey);
            break;
        }
        case "spareparts.machineMore": {
            const machineId = (props.params as SparePartsMachineMoreParams)?.machineId ?? "";
            const customerSiteCode = (props.params as SparePartsMachineMoreParams)?.customerSiteCode ?? "";
            const tabIndex = (props.params as SparePartsMachineMoreParams)?.tabIndex ?? "";
            url = goToPage.spareParts.getMachineMoreUrl(customerSiteCode, machineId, tabIndex);
            break;
        }
        case "spareparts.partDetails": {
            const partCode = (props.params as PartDetailsParams).partCode ?? "";
            url = goToPage.spareParts.getPartDetailsUrl(partCode);
            break;
        }
        case "system.offerOrderHistory": {
            url = goToPage.system.getOfferOrderHistoryUrl();
            break;
        }
        default: {
            url = "/";
            break;
        }
    }

    if (props.disabled === true) {
        return <>{props.children}</>;
    }
    return (
        <>
            {props.tooltipTitle && (
                <Tooltip title={props.tooltipTitle} placement="top" disableInteractive>
                    <Link
                        to={url}
                        className={props.className}
                        {...(props.onClick ? { onClick: props.onClick } : {})}
                    >
                        {props.children}
                    </Link>
                </Tooltip>
            )}
            {!props.tooltipTitle && (
                <Link
                    to={url}
                    className={props.className}
                    style={{  color: "inherit" }}
                    {...(props.onClick ? { onClick: props.onClick } : {})}
                >
                    {props.children}
                </Link>
            )}
        </>
    );
};

export default GoToPage;
